// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"j7-z"};